import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DGCoinDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchDGCoinPlans } from "../../../../features/auth/store/dgcoinPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import DGCoin from "./DGCoin";

const DGCoinRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedDGCoinPlan, setSelectedDGCoinPlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { dgcoinPlans, loading, error } = useSelector(
    (state: RootState) => state.dgcoinPlans
  );

  useEffect(() => {
    const filters: any = {};
    if (statusFilter && statusFilter !== "") {
      filters.status = statusFilter;
    }
    if (searchTerm && searchTerm !== "") {
      filters.search = searchTerm;
    }

    dispatch(fetchDGCoinPlans(filters));
  }, [dispatch, statusFilter, searchTerm]);

  const handleDGCoinPlanClick = (dgcoinPlan: Product) => {
    setSelectedDGCoinPlan(dgcoinPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedDGCoinPlan(null);
  };

  if (showDetailView && selectedDGCoinPlan) {
    return (
      <DGCoinDetailView
        dgcoinPlan={{
          ...selectedDGCoinPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <DGCoin
      dgcoinPlans={dgcoinPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onDGCoinPlanClick={handleDGCoinPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default DGCoinRouter;
